import { useState, useEffect } from 'react'
import { get, post } from '../../../../lib/api'
import { getTokenAndUid } from '../../../../lib/utils'

export function useGetUsersData() {
  const [userData, setUserData] = useState({})
  const { uid } = getTokenAndUid()

  async function getUserData() {
    get('/user_api/user.get_creator_details?is_novel=1').then((res) => {
      setUserData(res.result)
    })
  }

  function updateInviteCode(inviteCode) {
    post('/user_api/user.create_creator_account?is_novel=1', {
      data: {
        invite_code: inviteCode,
        languages: userData.languages || '',
        account_type: userData.account_type || '',
        user_id: uid,
        device_id: localStorage.getItem('uuid'),
      },
    })
  }

  useEffect(() => {
    getUserData()
  }, [])

  return {
    userData,
    updateInviteCode,
  }
}
